import angular from 'angular'
import { deduction } from 'redevConfig'

const list = (deduction && deduction.list) || ''
const detail = (deduction && deduction.detail) || ''
const report = (deduction && deduction.report) || ''
const testpdf = (deduction && deduction.testpdf) || ''

const deductListPage = list ? require(`redevelopment/input/deduction/${list.templateName}`) : require('./view/deductionList.html')
const deductionListCtrl = list ? require(`redevelopment/input/deduction/${list.controllerName}`) : require('./deductionListCtrl')
const reimburseDetailPage = detail ? require(`redevelopment/input/deduction/${detail.templateName}`) : require('./view/deductionDetail.html')
const deductionDetailCtrl = detail ? require(`redevelopment/input/deduction/${detail.controllerName}`) : require('./deductionDetailCtrl')
const deductReportPage = report ? require(`redevelopment/input/deduction/${report.templateName}`) : require('./view/deductReport.html')
const deductReportCtrl = report ? require(`redevelopment/input/deduction/${report.controllerName}`) : require('./deductReportCtrl')
const testpdfPage = testpdf ? require(`redevelopment/input/deduction/${testpdf.templateName}`) : require('./view/testpdf.html')
const testpdfCtrl = testpdf ? require(`redevelopment/input/deduction/${testpdf.controllerName}`) : require('./testpdfCtrl')

export default angular
    .module('input.reimburseManage.deduction', []).config(['$stateProvider', function config($stateProvider) {
        $stateProvider
            .state('input.reimburseManage.deduction', {
                url: '/deduction',
                abstract: true,
                template: '<div ui-view></div>',
                default: 'input.reimburseManage.deduction.list',
                title: '报销抵扣',
            })
            .state('input.reimburseManage.deduction.list', {
                url: '/list',
                template: deductListPage,
                controller: 'deductionListCtrl',
            })
            .state('input.reimburseManage.deduction.detail', {
                url: '/detail/:expenseId',
                template: reimburseDetailPage,
                controller: 'deductionDetailCtrl',
                title: '报销详情',
            })
            .state('input.reimburseManage.deduction.report', {
                url: '/report',
                template: deductReportPage,
                controller: 'deductReportCtrl',
                title: '报销报告',
            })
            .state('input.reimburseManage.deduction.testpdf', {
                url: '/testpdf',
                template: testpdfPage,
                controller: 'testpdfCtrl',
                title: '报销报告',
            })
    }])
    .controller('deductionListCtrl', deductionListCtrl.default)
    .controller('deductionDetailCtrl', deductionDetailCtrl.default)
    .controller('deductReportCtrl', deductReportCtrl.default)
    .controller('testpdfCtrl', testpdfCtrl.default)
    .name



// WEBPACK FOOTER //
// ./src/app/input/reimburseManage/deduction/index.js